import {useEffect, useRef} from "react";
import Container from "./Container";
import {moveVideoBox} from "../helpers/animations";

export default function TextWithVideo({
                                          video,
                                          childrenClasses = 'max-w-md',
                                          children,
                                          videoOffset = 0.08,
                                          boxOffset = -0.1,
                                          minWinSize = 768
                                      }) {

    const refVideo = useRef();
    const refBox = useRef();

    useEffect(() => {
        const handleScroll = () => {
            if (refVideo.current && refBox.current) {
                moveVideoBox(refVideo, refBox, videoOffset, boxOffset, minWinSize);
            }
        };

        window?.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window?.removeEventListener('scroll', handleScroll);
    }, [boxOffset, videoOffset, minWinSize]);

    return (
        <Container>
            <section className="flex flex-col md:flex-row items-center md:items-stretch md:gap-20 md:gap-16">

                <div className="relative w-full flex-1">
                    <div
                        className="block absolute w-[60%] aspect-[6/7] top-2/4 md:top-1/3 left-1 md:left-[50%] lg:left-[45%] bg-white shadow-lg rounded-md ease-out transition-transform duration-500"
                        ref={refBox}
                    />

                    <div
                        className="relative flex ml-auto rounded-md overflow-hidden ease-out transition-transform duration-1000 will-change-transform aspect-[19/21] max-w-[500px]"
                        ref={refVideo}>
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            preload='metadata'
                            className='absolute w-full h-full object-cover'
                        >
                            <source
                                src={video}
                                type='video/mp4'
                            />
                        </video>
                    </div>
                </div>

                <div className="relative flex-1">
                    <div className={childrenClasses}>
                        {children}
                    </div>
                </div>
            </section>
        </Container>
    )
}
